import { h, Host } from "@stencil/core";
/**
 * This component is intended to be used as a child of the ux-input component.
 */
export class Unit {
    constructor() {
        this.unit = "";
    }
    /**
     * The host element for the `Unit` component.
     */
    host;
    render() {
        return h(Host, { key: '9d5c5dc8d8c853e031945013ce742763e4162572' }, this.unit);
    }
    static get is() { return "ux-unit"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["unit.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["unit.css"]
        };
    }
    static get properties() {
        return {
            "unit": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The unit of measurement to be displayed"
                },
                "attribute": "unit",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=unit.js.map
